export default __webpack_public_path__ + "static/media/mockUp_minimap_app1.d467550c.png";